import { purchaseModelCode } from '@otovo/shared/cloudEnums';
import { Sanity$ProductSection } from '@otovo/shared/types/sanityTypes';
import cx from 'classnames';
import { useState } from 'react';
import PriceCard from './PriceCard';
import PriceRowHeading from './PriceRowHeading';

type Props = {
  content: Sanity$ProductSection;
};

const PriceRow = ({ content }: Props) => {
  const { productSectionDisplayType } = content;

  const [displaySubscriptionPrice, setDisplaySubscriptionPrice] =
    useState<boolean>(productSectionDisplayType !== purchaseModelCode.BUY_NOW);

  const numberOfProducts = content.products.length;

  return (
    <div className="bg-grey-90 pb-10 text-white">
      <div className="m-auto max-w-7xl">
        <PriceRowHeading
          description={content.description}
          heading={content.heading}
          buyNowText={content.buyNowButtonText}
          subscriptionText={content.subscriptionButtonText}
          setDisplaySubscriptionPrice={setDisplaySubscriptionPrice}
          displaySubscriptionPrice={displaySubscriptionPrice}
          productSectionDisplayType={productSectionDisplayType}
        />

        <div
          className={cx(
            'mx-8 flex flex-col gap-10 md:pb-20 lg:flex-row',
            `${numberOfProducts > 2 ? 'md:mt-10 md:gap-3' : ''}`,
          )}
        >
          {content.products &&
            content.products.map((product) => (
              <PriceCard
                key={product._id}
                product={product}
                displaySubscriptionPrice={displaySubscriptionPrice}
                productSectionDisplayType={productSectionDisplayType}
                numberOfProducts={numberOfProducts}
              />
            ))}
        </div>
      </div>
    </div>
  );
};
export default PriceRow;
